import { Theme, styled } from '@material-ui/core';
import { FeedbackIndicator } from 'src/modules/feedback';
import { PageTitle } from 'src/modules/shared/components';

export const StyledTotalExercisesByLevel = styled('div')({
  marginTop: '1rem',
});

export const StyledLabel = styled('span')<Theme>(({ theme }) => ({
  color: theme.palette.grey['700'],
  fontStyle: 'italic',
}));

export const IconButtonsWrapper = styled('div')({
  position: 'absolute',
  top: '0.5rem',
  right: '0.5rem',
});

export const ChapterNumberContainer = styled('div')({
  display: 'flex',
  minHeight: '4rem',
  width: 150,
  '& .clipboard-trajectory-button': {
    display: 'none',
  },
  '&:hover': {
    '& .clipboard-trajectory-button': {
      display: 'inline-block',
    },
  },
});

export const PageHeader = styled('div')<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const Wrapper = styled('div')<Theme>(({ theme }) => ({
  position: 'relative',
  marginTop: theme.spacing(3),
}));

export const FullscreenWrapper = styled('div')<Theme, { factor: number }>(({ theme, factor }) => ({
  transform: `scale(${factor})`,
  transformOrigin: 'top center',
  paddingBottom: theme.spacing(1),
}));

export const StyledPageTitle = styled(PageTitle)<Theme>(({ theme }) => ({
  [theme.breakpoints.down('xs')]: {
    paddingLeft: 0,
  },
}));

export const PageFeedbackIndicator = styled(FeedbackIndicator)({
  position: 'fixed',
  top: 0,
  right: '-3.7rem',
  display: 'flex',
  justifyContent: 'flex-end',
  transform: 'translate(50%, 50%)',
});
